<template>
  <custom-dialog width="800px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" ref="form" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.suo_shu_ying_yong')" prop="appId">
              <custom-select v-model="form.appId" url="AppMenu" :props="{ label: 'appName', value: 'appId' }" :dataFilter="dataFilter"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.suo_shu_cai_dan')" prop="menuId">
              <custom-select
                v-model="form.menuId"
                :listener="form.appId"
                url="MenuTree"
                type="tree"
                :auto="!!form.appId"
                :cascaderKey="form.appId"
                :params="{ appId: form.appId }"
                :show-all-levels="false"
                :props="{ label: 'menuName', value: 'menuId', checkStrictly: true, emitPath: false }"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.biao_ge_dai_ma')" prop="tableCode">
              <el-input v-model="form.tableCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.zi_duan_ming_cheng')" prop="columnName">
              <el-input v-model="form.columnName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.zi_duan_dai_ma')" prop="columnCode">
              <el-input v-model="form.columnCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.duo_yu_yan_dai_ma')" prop="langColumnName">
              <el-input v-model="form.langColumnName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.lie_kuanpx')" prop="width">
              <el-input type="number" min="0" v-model.number="form.width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.xian_shi_shun_xu')" prop="showOrder">
              <el-input type="number" :min="0" v-model.number="form.showOrder"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.mo_ren_xian_shi')">
              <el-switch v-model="form.defaultShow" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.duo_xuan')">
              <el-switch v-model="form.checkbox" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.gu_ding')">
              <el-switch v-model="form.isFixed" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.ke_pai_xu')">
              <el-switch v-model="form.isSort" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.ge_shi_hua')">
              <el-switch v-model="form.isFormat" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Common.com_export')">
              <el-switch v-model="form.isExport" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.ge_shi_hua_gui_ze')" prop="formatRule">
              <custom-select v-model="form.formatRule" code="bas_tableField_formatRule" :props="{ label: 'name', value: 'code' }" @change="form.dicGroup = ''"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.zdfzdm')" prop="dicGroup">
              <custom-select
                v-model="form.dicGroup"
                :props="{ label: 'nameCode', value: 'code', checkStrictly: true, emitPath: false }"
                type="tree"
                :code="form.formatRule === 'tableField_date' ? 'bas_tableField_dateFormat' : null"
                :url="form.formatRule ? 'DictGroupSelectTree' : ''"
                :cascaderKey="form.formatRule"
                :show-all-levels="false"
                :auto="model.type === 'edit'"
                :params="{}"
                :filterable="true"
                :listener="form.formatRule"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_column_dialog.zi_dian_jian_xuan_ze')" prop="checkboxRule">
              <el-input v-model="form.checkboxRule" :placeholder="$t('base_table_column_dialog.zdjdhfgbtbsqb')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveColumn(true)" v-if="model.type === 'add'">{{ $t('base_table_column_dialog.ji_xu_tian_jia') }}</el-button>
      <el-button type="primary" @click="saveColumn()">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appTree: [],
      formatRules: [],
      dictionarys: [],
      form: {
        columnId: '',
        menuId: '',
        appId: '',
        width: 0,
        showOrder: 0,
        columnCode: '',
        columnName: '',
        dicGroup: null,
        langColumnName: '',
        formatRule: '',
        tableCode: '',
        checkboxRule: '',
        defaultShow: 1,
        isFixed: 0,
        isExport: 1,
        isFormat: 0,
        checkbox: 0,
        isSort: 0,
      },
    };
  },
  computed: {
    rules() {
      return {
        width: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        showOrder: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        appId: {
          required: true,
          message: this.$t('base_table_column_dialog.ssyybx'),
        },
        menuId: {
          required: true,
          message: this.$t('base_table_column_dialog.sscdbx'),
        },
        tableCode: [
          {
            required: true,
            message: this.$t('base_table_column_dialog.bgdmbt'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        columnName: [
          {
            required: true,
            message: this.$t('base_table_column_dialog.zdmcbt'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        columnCode: [
          {
            required: true,
            message: this.$t('base_table_column_dialog.zddmbt'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        langColumnName: [
          {
            required: true,
            message: this.$t('base_table_column_dialog.dyydmbt'),
          },
          { max: 80, message: this.$t('Common.com_rules_length_max', [80]), },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    dataFilter: function (list) {
      return list.filter((t) => t.appCode !== 'isynergy_cloud');
    },
    // 初始化
    initDialog: function () {
      this.resetForm = JSON.stringify(this.form);
      this.form.appId = this.model.data.appId || '';
      this.form.menuId = this.model.data.menuId || '';
      if (this.model.type === 'edit') {
        const row = this.model.data.item;
        row.dicGroup = row.dicGroup || null;
        this.$setFormatData(this.form, row);
      }
    },
    // 确认保存
    saveColumn: function (isContinue) {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddColumn(isContinue);
        }
        if (this.model.type === 'edit') {
          this.saveEditColumn(isContinue);
        }
      });
    },
    // 保存新增
    saveAddColumn: function (isContinue) {
      if (!this.form.langColumnName.startsWith(this.form.tableCode)) {
        this.form.langColumnName = `${this.form.tableCode}_${this.form.langColumnName}`;
      }
      this.$postJSON(apis.TableColumnAdd, this.form, true)
        .then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          if (isContinue) {
            const tableCode = this.form.tableCode;
            const appId = this.form.appId;
            const menuId = this.form.menuId;
            const showOrder = this.form.showOrder + 5;
            this.form = JSON.parse(this.resetForm);
            this.form.tableCode = tableCode;
            this.form.showOrder = showOrder;
            this.form.appId = appId;
            this.form.menuId = menuId;
            this.$refs.form.resetFields();
          } else {
            this.visible = false;
          }
        })
        .catch(() => {});
    },
    // 保存编辑
    saveEditColumn: function () {
      this.$postJSON(apis.TableColumnUpdate, this.form, true)
        .then(() => {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
          this.$emit('success', this.form);
          this.visible = false;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss"></style>
